import { useRef, useEffect, useState } from "react";
import { Sliders, X } from "react-feather";

import { Chip, SearchBar } from "../../../../components/DesignSystem";

import { ListSearchResults } from "../ListSearchResults";
import { SidebarItem } from "../SidebarItem";
import Sort from "../Sort";
import Spinner from "../../../../components/Spinner";
import DownloadButton from "../../../../components/DownloadButton";
import "./index.scss";
import { useSelector } from "react-redux";

import SignDraft from "../../../../components/SignDraft";
import UsersButton from "../../../../components/UsersButton";

function SideBar({
  filters,
  isOpenId,
  isLoading,
  searchIsActive,
  handleSelectCase,
  setOrder,
  handleClose,
  handleChangeFilters,
  handleChangeSearch,
  handleDownloadExcel,
  isLoadingExcel,
  handleMetricsExcel,
  isLoadingMetricsExcel,
  caseMode,
  setCaseMode,
}) {
  const filterListRef = useRef(null);
  const [startX, setStartX] = useState(0);
  const [isDown, setIsDown] = useState(false);
  const [scrollLeft, setScrollLeft] = useState(0);
  const clickIsDisabled = useRef(null);
  const { searchResults, cases } = useSelector((state) => state.crm);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const sortOptions = [
    { title: "Não Lido", action: () => setOrder(["viewed_company", "DESC"]) },
    { title: "Mais Recentes", action: () => setOrder(["updated", "DESC"]) },
    { title: "Mais Antigos", action: () => setOrder(["updated", "ASC"]) },
    { title: "A-Z", action: () => setOrder(["corporate_name", "ASC"]) },
    { title: "Z-A", action: () => setOrder(["corporate_name", "DESC"]) },
  ];

  useEffect(() => {
    const { current } = filterListRef;
    const horizontalScroll = (e) => {
      if (e.deltaY > 0) current.scrollLeft += 10;
      else current.scrollLeft -= 10;
    };
    current.addEventListener("wheel", horizontalScroll);
    return () => current.removeEventListener("wheel", horizontalScroll);
  }, []);

  useEffect(() => {
    const { current } = filterListRef;

    function onMouseDown(event) {
      clickIsDisabled.current = false;
      setIsDown(true);
      setStartX(event.pageX - current.offsetLeft);
      setScrollLeft(current.scrollLeft);
    }

    function onMouseLeave() {
      setIsDown(false);
    }

    function onMouseUp() {
      setIsDown(false);
    }

    function onMouseMove(event) {
      if (!isDown) return;
      event.preventDefault();
      const x = event.pageX - current.offsetLeft;
      const walk = x - startX;
      if (current.scrollLeft === scrollLeft - walk) {
        clickIsDisabled.current = false;
      } else {
        clickIsDisabled.current = true;
      }
      current.scrollLeft = scrollLeft - walk;
    }

    current.addEventListener("mousedown", onMouseDown);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("mouseup", onMouseUp);
    current.addEventListener("mousemove", onMouseMove);

    return () => {
      current.removeEventListener("mousedown", onMouseDown);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("mouseup", onMouseUp);
      current.removeEventListener("mousemove", onMouseMove);
    };
  }, [isDown, startX, scrollLeft]);

  //#region handlers
  function handleClickCase(item) {
    handleSelectCase(item.caseId);
  }
  //#endregion

  function checkEmptyListing(values) {
    if (Array.isArray(values)) {
      return values.length === 0;
    }

    let searchResultsNotEmpty = true;
    Object.keys(values).forEach((item) => {
      if (values[item]) {
        searchResultsNotEmpty = false;
      }
    });

    return searchResultsNotEmpty;
  }

  function renderCaseList() {
    if (isLoading) {
      return <Spinner size={24} containerHeight="100%" />;
    }

    if (searchIsActive) {
      if (checkEmptyListing(searchResults)) {
        return <p>Nenhum caso encontrado</p>;
      }
      return (
        <ListSearchResults results={cases} handleClickCase={handleClickCase} />
      );
    }

    if (checkEmptyListing(cases)) {
      return <p>Nenhum caso encontrado</p>;
    }

    const casesByMode = [...cases].filter((c) => c.typeId === caseMode);

    return (
      <>
        {casesByMode.map((item, index) => (
          <SidebarItem
            key={item.caseId}
            item={item}
            index={index}
            isOpenId={isOpenId}
            handleClickCase={handleClickCase}
          />
        ))}
      </>
    );
  }

  function handleCloseModal() {
    setModalIsOpen(false);
  }

  return (
    <div className="sidebar">
      <header className="sidebar__header">
        <X className="sidebar__close" onClick={handleClose} />
        <div className="sidebar__header__title">
          <h2>Meus casos</h2>
          <Sort defaultValue="Não Lido" options={sortOptions} />
        </div>
        <SearchBar size="small" placeholder="" onChange={handleChangeSearch} />
        <DownloadButton
          onClick={
            caseMode === 1
              ? () => handleDownloadExcel.financial()
              : () => handleDownloadExcel.judicial()
          }
          title="Baixar relatório de casos"
          loading={isLoadingExcel}
        />
        <DownloadButton
          onClick={() => handleMetricsExcel()}
          title="Baixar relatório de métricas"
          loading={isLoadingMetricsExcel}
        />
        {/* <UsersButton
          onClick={() => setModalIsOpen(true)}
          title="Assinantes da Minuta"
        /> */}

        <div className="sidebar__header__case-mode">
          <label>
            <input
              value={1}
              type="radio"
              name="case-mode"
              checked={caseMode === 1}
              onChange={() => setCaseMode(1)}
            />
            <span className="custom-radio"></span>
            Financeiro
          </label>
          <label>
            <input
              value={2}
              type="radio"
              name="case-mode"
              checked={caseMode === 2}
              onChange={() => setCaseMode(2)}
            />
            <span className="custom-radio"></span>
            Judicial
          </label>
        </div>
      </header>

      <div className="sidebar__filters">
        <div className="sidebar__filters__title">
          <Sliders size={16} />
          Status
        </div>
        <div
          ref={filterListRef}
          className={`sidebar__filters__list ${
            isDown ? "sidebar__filters__list--mousedown" : ""
          }`}
        >
          {filters.map((filter) => (
            <Chip
              key={filter.label}
              selected={filter.active}
              selectedColor="green"
              onClick={() => {
                if (!clickIsDisabled.current) {
                  handleChangeFilters(filter.label);
                }
              }}
            >
              {filter.label}
            </Chip>
          ))}
        </div>
      </div>
      <div className="sidebar__cases">{renderCaseList()}</div>

      <SignDraft show={modalIsOpen} onClose={handleCloseModal} />
    </div>
  );
}

export default SideBar;
